import type { ComponentType } from 'react'
import { Car, ForkKnife, HouseLine, Scissors, Tooth, type IconProps } from '@phosphor-icons/react'

/** Industries with a page of their own under /dlya/. The home page shows
 * them as cards; a card links to its page once that page is in
 * SITE_PAGES, so no card ever points at a 404. */
export interface IndustryPage {
  path: string
  title: string
  text: string
  icon: ComponentType<IconProps>
}

export const INDUSTRY_PAGES: IndustryPage[] = [
  {
    path: '/dlya/stomatologii',
    title: 'Стоматології та медичні клініки',
    text: 'Записує до потрібного лікаря у вільне вікно, відповідає про ціни й підготовку до прийому.',
    icon: Tooth,
  },
  {
    path: '/dlya/avtoservisu',
    title: 'Автосервіси',
    text: 'Розпитує марку, рік і симптоми, записує на діагностику і передає заявку майстру.',
    icon: Car,
  },
  {
    path: '/dlya/restoraniv-i-dostavky',
    title: 'Ресторани й доставка',
    text: 'Бронює столики, відповідає про меню, години роботи й зону доставки, приймає замовлення.',
    icon: ForkKnife,
  },
  {
    path: '/dlya/nerukhomosti',
    title: 'Агенції нерухомості',
    text: 'Відповідає на дзвінки за оголошеннями, уточнює запит і записує на перегляд.',
    icon: HouseLine,
  },
  {
    path: '/dlya/saloniv-krasy',
    title: 'Салони краси',
    text: 'Знає майстрів і послуги, пропонує найближчий вільний час і записує навіть уночі.',
    icon: Scissors,
  },
]
